export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收件人："])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到用户"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联系方式"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["详细信息"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择用户"])}
}